import { instance } from "../interceptor";
import { THost } from "./setting/type";
import { ColorRes, THostByPurpose, TVisit, TVisitInfo, TVisitorDashboardRes } from "./type";
import * as Sentry from "@sentry/react";
import { changeActiveEntryLogging } from "./setting";

export { changeActiveEntryLogging };

export async function getVisitorsHosts(): Promise<THostByPurpose[]> {
    try {
        const res = await instance.get("/visitors/host");
        return res.data.hostListByPurpose;
    } catch (error) {
        Sentry.captureException(error);
        return [];
    }
}

export async function addVisitorsHosts(members: THost[], purposeId: string): Promise<boolean> {
    try {
        const res = await instance.patch("/visitors/host", {
            visitorsSettingPurposeId: purposeId,
            memberList: members,
        });
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error, { extra: { members: members, purposeId: purposeId } });
        return false;
    }
}

export async function updateAllEmployeesHostSetting(purposeId: string, applyAllEmployees: boolean): Promise<boolean> {
    try {
        const res = await instance.patch("/visitors/host/all-employees", {
            visitorsSettingPurposeId: purposeId,
            applyAllEmployees: applyAllEmployees,
        });
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error, { extra: { purposeId: purposeId, applyAllEmployees: applyAllEmployees } });
        return false;
    }
}

/**
 * 본인 담당인 방문자 기록 수정하기
 * @param visitorInfo 수정할 방문 정보
 * @returns
 */
export async function updateVisitorInfo(visitorInfo: TVisitInfo): Promise<TVisit | undefined> {
    try {
        const res = await instance.patch("/visitors/record", visitorInfo);

        return res.data;
    } catch (error: any) {
        Sentry.captureException(error, { extra: visitorInfo });
        if (error && error.response.status === 403) {
            alert("수정할 수 없는 일정입니다.");
        }
    }
}

export async function saveColor(primary: string): Promise<boolean> {
    try {
        const res = await instance.patch("/visitors/setting/color", {
            primary: primary,
        });
        return res.data.result;
    } catch (error: any) {
        Sentry.captureException(error, { extra: { primary: primary } });
        return false;
    }
}

export async function getColor(): Promise<ColorRes | null> {
    try {
        const res = await instance.get("/visitors/setting/color");
        return res.data;
    } catch (error) {
        Sentry.captureException(error);
        return null;
    }
}

export async function deleteRsv(id: string) {
    try {
        const res = await instance.delete("/visitors/record", {
            data: {
                id: id,
            },
        });

        return res.data.result;
    } catch (error) {
        Sentry.captureException(error, { extra: { id: id } });
    }
}

export async function getIconList(): Promise<{ id: number; imageUrl: string }[]> {
    try {
        const res = await instance.get("/visitors/setting/walk-in-visit/icon");
        return res.data;
    } catch (error) {
        Sentry.captureException(error);
        return [];
    }
}

export async function getVisitRecord(visitId: string): Promise<TVisit | null> {
    try {
        const res = await instance.post("/visitors/record", {
            id: visitId,
        });
        return res.data;
    } catch (error) {
        Sentry.captureException(error, { extra: { visitId: visitId } });
        return null;
    }
}

export async function getVisitorDashboard(page: number, start: Date, end: Date): Promise<TVisitorDashboardRes | null> {
    try {
        const res = await instance.post("/analytics/visitors/datatable/visitor", {
            page: page,
            period: {
                start: start.toISOString(),
                end: end.toISOString(),
            },
        });

        return res.data;
    } catch (error) {
        Sentry.captureException(error, {
            extra: {
                page: page,
                period: {
                    start: start.toISOString(),
                    end: end.toISOString(),
                },
            },
        });
        return null;
    }
}

export async function hideConnectPersonalCalendarWarning(): Promise<boolean> {
    try {
        const res = await instance.patch("/visitors/connect-personal-calendar/modal");
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error);
        return false;
    }
}

export async function hideDetectPersonalCalendarWarning(): Promise<boolean> {
    try {
        const res = await instance.patch("/visitors/detect-personal-calendar/modal");
        return res.data.result;
    } catch (error) {
        Sentry.captureException(error);
        return false;
    }
}
